import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltDataGenerationService {

  constructor(private http: HttpClient) { }

  /**
   * Get SLT Data Generation Response from the API
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param clientKey Client key from GlobalService
   * @param submissionId Submission ID from rowData
   * @param leKey LE Key from rowData
   * @param filingGroupKey Filing group key from rowData
   * @returns Observable with data generation response
   */
  getSltDataGenerationData(
    baseUrl: string,
    clientKey: any,
    submissionId: any,
    leKey: any,
    filingGroupKey: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32716&client_key=${clientKey}&submission_id=${submissionId}&le_key=${leKey}&filing_group_key=${filingGroupKey}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }
}
